/**
 * Verlof React Query Hooks (Spoor 2, Verlof MVP)
 */

import { useQuery } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';

export const leaveKeys = {
  all: ['leave-requests'] as const,
  mine: () => [...leaveKeys.all, 'me'] as const,
};

/**
 * Story 1.2: eigen verlofoverzicht (saldo + historie).
 *
 * `enabled` bestaat voor het namens-een-ander-pad: dit is het saldo van de
 * INGELOGDE gebruiker, dus bij een aanvraag voor iemand anders moet het
 * niet alleen verborgen blijven maar ook niet opgehaald worden.
 */
export function useMijnVerlof(enabled = true) {
  return useQuery({
    queryKey: leaveKeys.mine(),
    queryFn: () => verlofApi.getMyOverview(),
    staleTime: 1000 * 60, // 1 min cache — balances/history change on submit/decide
    enabled,
  });
}
